import { Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { LoginEmailForm } from "./login-email-form";

export const Login = () => {
  const { t } = useTranslation();

  return (
    <VStack w="full" flex={1} justify="center" spacing={0}>
      <VStack w="full" maxW="440px" spacing={0} px={4}>
        <Text
          fontFamily="'Barlow Condensed', sans-serif"
          fontSize="28px"
          fontWeight={700}
          color="#13192E"
          textAlign="center"
          mb="6px"
        >
          {t("login.title")}
        </Text>
        <Text
          fontSize="16px"
          color="slate.500"
          textAlign="center"
          mb={7}
        >
          {t("login.subtitle")}
        </Text>

        <LoginEmailForm />
      </VStack>
    </VStack>
  );
};
